module.exports = __webpack_public_path__ + "img/forum2.d5afd787.jpg";